import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface AdminState {
  selectedTenantId: string | null;
  searchFilter: string;
}

const initialState: AdminState = {
  selectedTenantId: null,
  searchFilter: '',
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setSelectedTenant: (state, action: PayloadAction<string | null>) => {
      state.selectedTenantId = action.payload;
    },
    setAdminSearchFilter: (state, action: PayloadAction<string>) => {
      state.searchFilter = action.payload;
    },
  },
});

export const { setSelectedTenant, setAdminSearchFilter } = adminSlice.actions;
export const selectSelectedTenantId = (state: { admin: AdminState }) =>
  state.admin.selectedTenantId;
export const selectAdminSearchFilter = (state: { admin: AdminState }) => state.admin.searchFilter;
export default adminSlice.reducer;
